/* Bierschool — vensters voor "Lees de hele uitleg" (bron: vat33/shopify-theme/hoptimaal/assets/bierschool.js) */
(function () {
  "use strict";
  document.addEventListener("click", function (e) {
    var open = e.target.closest("[data-bs-open]");
    if (open) {
      var d = document.getElementById(open.getAttribute("data-bs-open"));
      if (d && d.showModal) d.showModal();
      return;
    }
    if (e.target.closest("[data-bs-dicht]")) {
      e.target.closest("dialog").close();
      return;
    }
    if (e.target.tagName === "DIALOG") e.target.close(); // klik op de achtergrond
  });
})();
